"use client";

import { Form, Formik } from "formik";
import Link from "next/link";
import Input from "@/app/_forms/Input";
import Captcha from "@/app/_partials/Captcha";
import useLoginHandler from "../_hooks/useLoginHandler";
import { FormField, FormGroup, FormLabel } from "@/app/_forms/FormsStore";
import useUtility from "@/app/_hooks/useUtility";
import { Button } from "@/app/_partials/Button";
import Image from "next/image";
import { getFavicon, getLogo } from "@/lib/helpers";
import loginThumb from "@/public/images/thumbs/login-thumb.png";
import { useState } from "react";
import Logo from "@/public/images/thumbs/logo.png";

export default function LoginForm() {
  const { trans } = useUtility();
  const [showPassword, setShowPassword] = useState(false);

  const { initialValues, validationSchema, handleSubmit } = useLoginHandler();

  return (
    <>
      <header className="header header-two" id="header">
        <div className="container custom-container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <Link className="navbar-brand logo" href="/">
              <Image
                src={Logo}
                width={275}
                height={48}
                alt={trans("image")}
                priority
              />
            </Link>
            <button
              className="navbar-toggler header-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span id="hiddenNav" className="d-inline-flex">
                <i className="las la-bars"></i>
              </span>
            </button>

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav nav-menu align-items-lg-center w-100">
                <li className="nav-item buttons ms-auto">
                  <Link
                    className="btn btn-outline--warning btn--lg"
                    href="/register/step-1"
                  >
                    {trans("Register")}
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>

      <section className="account-section">
        <span className="account-section__gradient one"></span>
        <span className="account-section__gradient two"></span>
        <span className="account-section__gradient three"></span>
        <span className="account-section__gradient four"></span>
        <div className="container custom-container">
          <div className="account-section__inner">
            <div className="account-content">
              <h5 className="account-content__title text--base">
                {trans("Endless")} <br /> {trans("Possibilities")}
              </h5>
              <p className="account-content__desc">
                {trans(
                  "Streamline payments, convert currencies, Pay bills and manage transactions effortlessly with Belyfted.",
                )}
              </p>
              <div className="account-content__thumb">
                <Image
                  src={loginThumb}
                  width={400}
                  height={415}
                  alt={trans("image")}
                  priority
                />
              </div>
            </div>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, values }) => {
                return (
                  <Form className="account-form">
                    <div className="account-form__content text-center">
                      <Link href="/" className="account-form__logo">
                        <Image
                          src={getLogo()}
                          width={275}
                          height={48}
                          alt={trans("image")}
                          priority
                        />
                      </Link>
                      <h6 className="account-form__title text--base">
                        {trans("Sign In")}
                      </h6>
                      <p className="account-form__desc">
                        {trans("Login Your Account")}
                      </p>
                    </div>
                     <div style={{ display: "flex", alignItems: "flex-start", gap: "10px", background: "#f3f4f6", borderRadius: "12px", padding: "12px 14px", marginBottom: "16px" }}>
                      <span style={{ fontSize: "18px", color: "#f59e0b", flexShrink: 0, marginTop: "1px" }}>
                        <i className="fas fa-lock"></i>
                      </span>
                      <p style={{ margin: 0, fontSize: "13px", color: "#6b7280", lineHeight: "1.5" }}>
                        {trans("You are on the official Belyfted website")}{" "}
                        <a href="https://belyfted.com" target="_blank" rel="noopener noreferrer" style={{ color: "#f59e0b", textDecoration: "underline", fontWeight: 500 }}>
                          https://belyfted.com
                        </a>{" "}
                        — UK-regulated remittance and global payments.
                      </p>
                    </div>
                    <FormGroup>
                      <FormField
                        name={"username"}
                        label={trans("Username")}
                        required={true}
                        placeholder="Janedoe"
                      />
                    </FormGroup>
                    <FormGroup>
                      <div className="d-flex flex-wrap justify-content-between mb-2">
                        <FormLabel
                          name="password"
                          label="Password"
                          required={true}
                        />
                      </div>
                      <div className="position-relative">
                        <Input
                          name="password"
                          type={showPassword ? "text" : "password"}
                          required={true}
                          placeholder="Password"
                        />
                        <span
                          className={`password-show-hide fas toggle-password ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
                          onClick={() => setShowPassword(!showPassword)}
                        ></span>
                      </div>
                    </FormGroup>

                    <Captcha values={values} />

                    <div className="d-flex flex-wrap justify-content-between gy-3 mb-3">
                      <Link
                        href="password-reset-request"
                        className="anchor--link"
                      >
                        {trans("Forgot Password?")}
                      </Link>
                      {/* <Link
                        href="/register"
                        className="d-lg-none d-block text-center anchor--link"
                      >
                        {trans("Register")}
                      </Link> */}
                    </div>

                    <Button
                      loading={isSubmitting}
                      className="btn btn--warning w-100 mb-4"
                      label="Login"
                    />

                    <div className="text-center">
                      <p className="account-form__text d-flex justify-content-center align-items-center">
                        {trans("Don't have an account?")}&nbsp;
                        <Link href="/register/step-1" className="anchor--link">
                          {trans("Sign up")}
                        </Link>
                      </p>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </section>
    </>
  );
}
